import Highcharts from "Static/js/highstock";
import each from "lodash/each";
import PropTypes from "prop-types";
import React from "react";
import { utcToLocal } from "util/time";

class DiskChart extends React.PureComponent {
  static get propTypes() {
    return {
      data: PropTypes.array.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.chartElem = null;
    this.highchart = null;

    this.destroy = this.destroy.bind(this);
  }

  componentDidUpdate() {
    this._renderChart(this.props);
  }

  componentDidMount() {
    this._renderChart(this.props);
  }

  componentWillUnmount() {
    this.destroy();
  }

  destroy() {
    if (this.highchart) {
      this.highchart.destroy();
    }
  }

  _getData(props) {
    const data = props.data.reduce((acc, p) => {
      const [ts, free, total, label = "Disk"] = p;

      if (!acc[label]) {
        acc[label] = [];
      }

      acc[label].push([
        ts,
        parseFloat((((total - free) / total) * 100).toFixed(2)),
      ]);

      return acc;
    }, {});

    return Object.entries(data).map(([label, tsData]) => {
      return {
        name: label,
        data: tsData,
      };
    });
  }

  _renderChart(props) {
    const noData = props.data.length === 0;
    if (noData) {
      return;
    }

    const { chartElem } = this;
    const opts = {
      chart: {
        renderTo: chartElem,
        type: "line",
      },
      title: "Disk Usage Percentage",
      xAxis: {
        type: "datetime",
        labels: {
          enabled: true,
        },
      },
      tooltip: {
        formatter: function () {
          // Do not make this an arrow function.
          let t = utcToLocal(this.points[0].x) + "<br>";

          each(this.points, (p) => {
            t += `${p.series.name}: <b>${p.y}%</b><br>`;
          });

          return t;
        },
        shared: true,
      },
      yAxis: {
        title: "Disk Usage Percentage",
        type: "category",
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        startOnTick: false,
        showFirstLabel: true,
        showLastLabel: true,
      },
      series: this._getData(props),
      plotOptions: {
        series: {
          lineWidth: 1,
          marker: {
            enabled: false,
          },
        },
      },
      credits: {
        enabled: false,
      },
    };

    this.destroy();

    this.highchart = new Highcharts.Chart(opts);
  }

  render() {
    const noData = this.props.data.length === 0;

    return (
      <div
        className="chart disk-chart"
        ref={(c) => {
          this.chartElem = c;
        }}
      >
        {noData && <div>No data for chart.</div>}
      </div>
    );
  }
}

export { DiskChart };
